import { useModuleLicense } from './useModuleLicense';
import { RETAIL_SEATS } from './useStockSeat';

/**
 * Who sells (Rob, 2026-10-19: selling is the Sales module's, a hard cut).
 * Mirrors HHNodeServer `middleware/salesAccess.js`, which is the real gate.
 *
 *   sell  — a Sales User or Admin, or a Retail seat at its own counter:
 *           enters, edits and confirms orders, adds and edits customers.
 *   admin — the Sales Admin, or a Retail manager: also cancels an order and
 *           updates its prices.
 *
 * A Nursery seat reads orders and does the logistics (allocation, loads,
 * picking, despatch); that stays `useStockSeat`.
 */
export type SellLevel = 'sell' | 'admin';

const SEATS: Record<SellLevel, { sales: string[]; retail: string[] }> = {
  sell:  { sales: ['user', 'admin'], retail: RETAIL_SEATS },
  admin: { sales: ['admin'], retail: ['manager'] },
};

/** `alsoModules` for a `LicenseGate moduleKey="sales"` on a page a Retail seat also sells from. */
export function retailSells(level: SellLevel = 'sell') {
  return [{ moduleKey: 'retail', licenseType: SEATS[level].retail }];
}

export function useSellSeat(level: SellLevel = 'sell') {
  const sales = useModuleLicense('sales', SEATS[level].sales);
  const retail = useModuleLicense('retail', SEATS[level].retail);
  return {
    hasAccess: sales.hasAccess || retail.hasAccess,
    loading: sales.loading || retail.loading,
  };
}
